import { useEffect, useState, useCallback } from 'react'

let announcePoliteGlobal: ((message: string) => void) | null = null
let announceAssertiveGlobal: ((message: string) => void) | null = null

/**
 * 전역 스크린리더 라이브 리전에 메시지를 전달한다.
 * @param message 읽어줄 텍스트
 * @param priority 'assertive'면 즉시(멘션 등 긴급), 기본 'polite'는 자연스러운 시점에 읽어줌
 */
export function announce(message: string, priority: 'polite' | 'assertive' = 'polite') {
  if (priority === 'assertive') {
    announceAssertiveGlobal?.(message)
  } else {
    announcePoliteGlobal?.(message)
  }
}

export function AriaLiveRegion() {
  const [politeMessage, setPoliteMessage] = useState('')
  const [assertiveMessage, setAssertiveMessage] = useState('')

  const handlePolite = useCallback((msg: string) => {
    setPoliteMessage('')
    requestAnimationFrame(() => setPoliteMessage(msg))
  }, [])

  const handleAssertive = useCallback((msg: string) => {
    setAssertiveMessage('')
    requestAnimationFrame(() => setAssertiveMessage(msg))
  }, [])

  useEffect(() => {
    announcePoliteGlobal = handlePolite
    announceAssertiveGlobal = handleAssertive
    return () => {
      announcePoliteGlobal = null
      announceAssertiveGlobal = null
    }
  }, [handlePolite, handleAssertive])

  return (
    <>
      <div
        aria-live="polite"
        aria-atomic="true"
        role="status"
        className="sr-only"
      >
        {politeMessage}
      </div>
      <div
        aria-live="assertive"
        aria-atomic="true"
        role="alert"
        className="sr-only"
      >
        {assertiveMessage}
      </div>
    </>
  )
}
